import server from '@/api/simples_nacional/serveSimplesNacional'

export function getDeclaracaoSimples(cnpj, periodo) {
    return server({
        url: `/simples/extrato/${cnpj}/${periodo}`,
        method: 'get'
    })
}
